import SeatChoiceUIModel from './seat-choice';

class PaidSegmentChoiceUIModel {
  constructor({
    fareType = null,
    isGenericSeat = false,
    newSeat = false,
    seat = undefined,
    seatSelectionFee = null,
    segmentCode = undefined,
    status = null,
    redeemedCP = false,
  } = {}) {
    this.fareType = fareType;
    this.isGenericSeat = isGenericSeat;
    this.newSeat = newSeat;
    this.seat = new SeatChoiceUIModel(seat);
    this.seatSelectionFee = seatSelectionFee;
    this.segmentCode = segmentCode;
    this.status = status;
    this.isPaid = true;
    this.redeemedCP = redeemedCP;
  }

  hasSeatByCode(code) {
    return this.code === code;
  }

  toApi() {
    return {
      '_meta':{
        'class':'PaidSegmentChoice',
      },
      'segmentCode': this.segmentCode,
      'seat': this.seat.toApi(),
    };
  }
}

export default PaidSegmentChoiceUIModel;
